import React, { Component, Fragment } from 'react'
import TopNavigation from '../components/TopNavigation/header';
import PageTop from '../components/PageTop/PageTop';

import Footer from '../components/Footer/Footer';
import Visitor from '../components/Visitor/Visitor';
import VendorRegistration from '../components/VendorRegistration/VendorRegistration';

export class VendorRegistrationPage extends Component {
  render() {
    return (
      <Fragment>
        <TopNavigation></TopNavigation>
        <PageTop pageTitle="Vendorssss Registrations"></PageTop>
        <VendorRegistration></VendorRegistration>
                     
                         <Footer></Footer>
                   

      </Fragment>
    )
  }
}

export default VendorRegistrationPage
